document.addEventListener('DOMContentLoaded', () => {
    const productGrids = document.querySelectorAll('.product-grid'); // Renamed for clarity

    productGrids.forEach(grid => {
        const gridItems = grid.querySelectorAll('.grid__item');

        gridItems.forEach(gridItem => {
            gridItem.addEventListener('click', (e) => {
                const gridItemLink = gridItem.querySelector('a');

                if (gridItemLink) {
                    e.stopPropagation();
                    // Programmatically click the link to trigger its default behavior
                    gridItemLink.click();
                }
            });
        });
    });

    // Change Track Listing depending on the Product Variant
    const variantRadios = document.querySelector('variant-radios');

    if (!variantRadios) {
        return;
    }

    const formatInputs = variantRadios.querySelectorAll('input[type="radio"][name="Format"]');

    const trackListingContainer = document.querySelector('.track_listing_container') || document.body; 
    
    if (formatInputs.length > 0) {
        const updateTrackListing = (selectedValue) => {
            if (!selectedValue) return;
            const targetClassName = `.track_listing_${selectedValue.toLowerCase()}`;
            const allTrackListings = trackListingContainer.querySelectorAll('[class*="track_listing_"]');

            let foundMatch = false;

            allTrackListings.forEach(listing => {
                listing.style.display = 'none';

                if (listing.matches(targetClassName)) {
                    listing.style.display = '';
                    foundMatch = true;
                }
            });
        };

        formatInputs.forEach(input => {
            input.addEventListener('change', (event) => {
                const selectedValue = event.target.value;
                updateTrackListing(selectedValue);
            });
        });
        
        const initialCheckedInput = variantRadios.querySelector('input[type="radio"][name="Format"]:checked');
        if (initialCheckedInput) {
            updateTrackListing(initialCheckedInput.value);
        }
    }
});

// Additional JS 7 Aug 2025
class Accordion {
  constructor(el) {
    // Store the <details> element
    this.el = el;
    // Store the <summary> element
    this.summary = el.querySelector('summary');
    // Store the <div class="content"> element
    // this.content = el.querySelector('.accordion__content');
    this.content = el.querySelector('.facets__display-vertical'); // fix for vertical filter menu

    // Store the animation object (so we can cancel it if needed)
    this.animation = null;
    // Store if the element is closing
    this.isClosing = false;
    // Store if the element is expanding
    this.isExpanding = false;
    // Detect user clicks on the summary element
    this.summary.addEventListener('click', (e) => this.onClick(e));
  }

  onClick(e) {
    // Stop default behaviour from the browser
    e.preventDefault();
    // Add an overflow on the <details> to avoid content overflowing
    this.el.style.overflow = 'hidden';
    // Check if the element is being closed or is already closed
    if (this.isClosing || !this.el.open) {
      this.open();
    // Check if the element is being openned or is already open
    } else if (this.isExpanding || this.el.open) {
      this.shrink();
    }
  }

  shrink() {
    // Set the element as "being closed"
    this.isClosing = true;
    
    // Store the current height of the element
    const startHeight = `${this.el.offsetHeight}px`;
    // Calculate the height of the summary
    const endHeight = `${this.summary.offsetHeight}px`;
    
    // If there is already an animation running
    if (this.animation) {
      // Cancel the current animation
      this.animation.cancel();
    }
    
    // Start a WAAPI animation
    this.animation = this.el.animate({
      // Set the keyframes from the startHeight to endHeight
      height: [startHeight, endHeight]
    }, {
      duration: 300,
      easing: 'ease-out'
    });
    
    // When the animation is complete, call onAnimationFinish()
    this.animation.onfinish = () => this.onAnimationFinish(false);
    // If the animation is cancelled, isClosing variable is set to false
    this.animation.oncancel = () => this.isClosing = false;
  }

  open() {
    // Apply a fixed height on the element
    this.el.style.height = `${this.el.offsetHeight}px`;
    // Force the [open] attribute on the details element
    this.el.open = true;
    // Wait for the next frame to call the expand function
    window.requestAnimationFrame(() => this.expand());
  }

  expand() {
    // Set the element as "being expanding"
    this.isExpanding = true;
    // Get the current fixed height of the element
    const startHeight = `${this.el.offsetHeight}px`;

    const contentHeight = this.content ? this.content.offsetHeight : 0;

    // Calculate the open height of the element (summary height + content height)
    // const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;
    const endHeight = `${this.summary.offsetHeight + contentHeight}px`;
    
    // If there is already an animation running
    if (this.animation) {
      // Cancel the current animation
      this.animation.cancel();
    }
    
    // Start a WAAPI animation
    this.animation = this.el.animate({
      // Set the keyframes from the startHeight to endHeight
      height: [startHeight, endHeight]
    }, {
      duration: 300,
      easing: 'ease-out'
    });
    // When the animation is complete, call onAnimationFinish()
    this.animation.onfinish = () => this.onAnimationFinish(true);
    // If the animation is cancelled, isExpanding variable is set to false
    this.animation.oncancel = () => this.isExpanding = false;
  }

  onAnimationFinish(open) {
    // Set the open attribute based on the parameter
    this.el.open = open;
    // Clear the stored animation
    this.animation = null;
    // Reset isClosing & isExpanding
    this.isClosing = false;
    this.isExpanding = false;
    // Remove the overflow hidden and the fixed height
    this.el.style.height = this.el.style.overflow = '';
  }
}

document.querySelectorAll('details').forEach((el) => {
  new Accordion(el);
});

// Additional JS 17 October 2025
// Click on banner -> clicks on button, if it exists
const slideshowBanner = document.querySelector('.slideshow.banner');

if (slideshowBanner) {
  // const slides = slideshowBanner.querySelectorAll('.slideshow__slide');
  slideshowBanner.addEventListener('click', (e) => {
    // Check if the clicked element is a slide
    const slide = e.target.closest('.slideshow__slide');

    // If a slide was clicked, find its button and simulate the click
    if (slide) {
      const button = slide.querySelector('a.button');
      if (button) {
        button.click();
      }
    }
  });
}